import React from 'react';
import i18next from 'i18next';

import { IRestaurantCompany } from 'types';

const CompanyDetails: React.FC<{ company: IRestaurantCompany }> = ({
  company,
}) => {
  return (
    <>
      <div>{i18next.t('company-details.name')}: {company.name}</div>
      <div>{i18next.t('company-details.nip')}: {company.nip}</div>
      <div>{i18next.t('company-details.address')}: {company.address}</div>
      <div>
        {i18next.t('company-details.bank-account')}: {company.bank_account || i18next.t('company-details.none')}
      </div>
      {!!company.representer && (
        <div>
          <strong>{i18next.t('company-details.contact-person')}:</strong>
          <div>{company.representer.name}</div>
          <div>{company.representer.phone}</div>
        </div>
      )}
    </>
  );
};

export default CompanyDetails;
